module.exports = __webpack_public_path__ + "img/parcial.ff08bd76.svg";